
import React from "react";
import {
  FaBrain,
  FaClipboardList,
  FaChartLine,
  FaUserFriends,
  FaRobot,
  FaWheelchair,
  FaWaveSquare,
  FaBookOpen,
  FaCalendarCheck,
  FaCrown,
  FaThLarge,
  FaSearch,
} from "react-icons/fa";
import { useNavigate } from "react-router-dom";

export default function AIAppsGrid() {
  const navigate = useNavigate();

  const aiApps = [
    { label: "Content AI", icon: FaBrain, bg: "#2f7af4" },
    { label: "Planning AI", icon: FaClipboardList, bg: "#22a54f" },
    { label: "Progress AI", icon: FaChartLine, bg: "#f2680a" },
    { label: "Personalize AI", icon: FaUserFriends, bg: "#e72f6c" },
    { label: "Rooboo Assistant", icon: FaRobot, bg: "#8a4ff7" },
    { label: "Special AI", icon: FaWheelchair, bg: "#0ca1b7" },
    { label: "Performance AI", icon: FaWaveSquare, bg: "#0f9a6e" },
    { label: "Classroom AI", icon: FaBookOpen, bg: "#d4a20a" },
    { label: "Attendance AI", icon: FaCalendarCheck, bg: "#4a4de9" },
  ];

  const handleClick = (label) => {
    const name = label.toLowerCase().replace(/\s+/g, "");
    navigate(`/dashboard/teacher/${name}`);
  };

  return (
    <section className="mt-12">
      <div className="flex justify-between items-center mb-6 px-2 sm:px-0">
        <h2 className="text-gray-900 font-semibold text-lg flex items-center gap-2">
          <FaThLarge className="text-[#3b56f5]" />
          AI Apps
        </h2>
        <button className="flex items-center gap-1 bg-white shadow rounded-md px-4 py-2 text-[#3b56f5] text-sm font-semibold hover:bg-[#f3f5ff] transition">
          <FaSearch />
          Take Tour
        </button>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-5 gap-6">
        {aiApps.map((app) => (
          <div
            key={app.label}
            onClick={() => handleClick(app.label)}
            className="rounded-xl shadow-md p-6 flex flex-col items-center gap-3 cursor-pointer relative hover:scale-105 transition-transform"
            style={{ backgroundColor: app.bg }}
          >
            <app.icon className="text-white text-2xl" />
            <p className="text-white font-semibold text-base">{app.label}</p>
            <FaCrown className="text-yellow-400 absolute top-3 right-3 text-xs" />
          </div>
        ))}
      </div>
    </section>
  );
}